import { useState, type ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * A pop played by the viewer's own tap — following an event, giving a
 * reaction — never by a page drawing something already on (0081). `play`
 * names what popped; `wrap` draws it, replayed by its key each time.
 */
export function usePop() {
  const [last, setLast] = useState<{ what: string; times: number } | null>(null);
  return {
    play: (what: string) => setLast((was) => ({ what, times: (was?.times ?? 0) + 1 })),
    wrap: (what: string, children: ReactNode) => {
      const playing = last?.what === what;
      return (
        <span
          key={playing ? `pop-${last.times}` : "still"}
          className={cn("inline-flex", playing && "animate-pop motion-reduce:animate-none")}
        >
          {children}
        </span>
      );
    },
  };
}
